import React, { useCallback, useEffect, useState } from "react";
import { Grid, useTheme } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import Request from "../../../core/requests";
import { Loading } from "components/common";
import LineChartPlotly from "components/charts/LineChartPlotly.component";
import _ from "lodash";
import { openSnackbar } from "store/slices/snackbar";
import CurrentDataContainer from "containers/currentData/CurrentData.container";
import {
  propsTempertureCard,
  propsUmidityCard,
  propsCo2Card,
  propsLuxCard,
  propsBarPressCard,
  propsPM2_5Card,
  propsRainCard,
  propsWindCard,
  propsPCountCard,
  propsPM10Card,
  optionsMetrics,
  propsRainPeakCard,
} from "constants/metrics";
import {
  air_humLineChart,
  air_tempLineChart,
  bar_pressLineChart,
  co2LineChart,
  getMinMaxLineChart,
  luxLineChart,
  pmLineChart,
  windLineChart,
  pcountLineChart,
  rainLineChart,
} from "constants/charts";
import SelectZoneAndStationCard from "components/cards/select/SelectZoneAndStation.component";
import MetricCard from "components/cards/metrics/MetricCard.component";
import ErrorCardcomponent from "components/common/card/ErrorCard.component";
import SelectDateStartAndEndComponent from "components/cards/select/SelectDateStartAndEnd.component";
import { saveCluster, saveMetric, saveStationID } from "store/user.store";
import { DateTime } from "luxon";
import { blue, cyan, red } from "@mui/material/colors";
import { refreshToken, logout } from "store/user.store";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { getTimeZoneLondon, getTimeZoneStandard } from "utils/timezone";
import { WIND_DIRECTION_DICT360, getIconWindDirection } from "constants/wind";
import StatsContainer from "containers/dashboard/home/stats/StatsCurrent.container";

const GlobalEnviromentContainer = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const theme = useTheme();
  const navigate = useNavigate();
  const { token, refresh_token, global, cluster, stationID, user } =
    useSelector((state) => state.user);

  const [values, setValues] = useState(null);
  const [loading, setLoading] = useState(false);
  const [loadingData, setLoadingData] = useState(false);

  const [listClusters, setListClusters] = useState([]);
  const [listStationsId, setListStationsId] = useState([]);
  const [dataMetrics, setDataMetrics] = useState(null);
  const [zoneSelected, setZoneSelected] = useState(cluster ? cluster : []);
  const [stationIdSelected, setStationIdSelected] = useState(stationID);
  const [valueData, setValueData] = useState("24h");

  const [dateStart, setDateStart] = useState(null);
  const [dateEnd, setDateEnd] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [time, setTime] = useState(null);
  const [error, setError] = useState(false);
  const [dataStations, setDataStations] = useState(null);
  const [isFirstRefresh, setIsFirstRefresh] = useState(true);
  const [success, setSuccess] = useState(null);

  const onRefresh = useCallback(() => {
    setRefresh(true);
    setLoadingData(true);
  }, []);

  const handleChangeZone = useCallback((item) => {
    setZoneSelected(item);
    dispatch(saveCluster(item));
    setStationIdSelected(null);
    dispatch(saveStationID(null));

    setListStationsId([]);
    setLoadingData(true);
    // eslint-disable-next-line
  }, []);

  const handleChangeStationIdSelected = useCallback((item) => {
    setStationIdSelected(item);
    dispatch(saveStationID(item));
    setLoadingData(true);
    // eslint-disable-next-line
  }, []);

  const onChangeDateStart = useCallback(
    (item) => {
      setDateStart(item);
      setLoadingData(true);

      if (dateEnd === null && item === null) {
        setValueData("24h");
      } else {
        setValueData("");
      }
      //setValues(null);
    },
    // eslint-disable-next-line
    [dateEnd]
  );

  const onChangeDateEnd = useCallback(
    (item) => {
      setDateEnd(item);
      setLoadingData(true);

      if (dateStart === null && item === null) {
        setValueData("24h");
      } else {
        setValueData("");
      }
      //setValues(null);
    },
    // eslint-disable-next-line
    [dateStart]
  );

  const onChangeValueDate = useCallback((item) => {
    setValueData(item);
    setDateStart(null);
    setDateEnd(null);
    setLoadingData(true);

    // eslint-disable-next-line
  }, []);

  const onFailure = useCallback((error) => {
    setError(true);
    dispatch(
      openSnackbar({
        open: true,
        message: error.response?.data?.message ? error.response.data.message : "Errore",

        variant: "alert",
        alert: {
          color: "error",
        },
        close: false,
      })
    );
    //setValues(null);
    setLoadingData(false);
    // eslint-disable-next-line
  }, []);

  const onSuccess = useCallback((resp) => {
    setError(false);
    setValues(resp);
    setSuccess(true);
    setLoadingData(false);
    setIsFirstRefresh(true);
  }, []);

  const onLogout = useCallback((error) => {
    if (error?.response?.status === 403 || error?.response?.status === 401) {
      dispatch(logout());
    }
    // eslint-disable-next-line
  }, []);

  const onError = useCallback(
    (error) => {
      if (isFirstRefresh) {
        setLoadingData(false);
        if (error?.response?.status === 403) {
          onLogout(error);
        } else {
          if (error?.response?.status !== 401) {
            onFailure(error);
          } else {
            if (isFirstRefresh) {
              dispatch(
                refreshToken({
                  grant_type: "refresh_token",
                  refresh_token: user.refresh_token,
                })
              );
              setIsFirstRefresh(false);
            }
          }
        }
      } else {
        onLogout(error);
      }
    },
    // eslint-disable-next-line
    [isFirstRefresh, refresh_token]
  );

  const onClickCard = useCallback((item) => {
    if (item === "wind_speed" || item === "wind_dir_idx") {
      dispatch(
        saveMetric(
          _.find(optionsMetrics, (e) => e.value === "wind_speed,wind_dir_idx")
        )
      );
    } else {
      if (item === "rain_intensity" || item === "rain_intensity_peak") {
        dispatch(
          saveMetric(
            _.find(
              optionsMetrics,
              (e) => e.value === "rain_intensity,rain_intensity_peak"
            )
          )
        );
      } else if (item === "pm10" || item === "pm2_5") {
        dispatch(
          saveMetric(_.find(optionsMetrics, (e) => e.value === "pm10,pm2_5"))
        );
      } else {
        dispatch(saveMetric(_.find(optionsMetrics, (e) => e.value === item)));
      }
    }
    navigate("/dashboard/data-sensors/metrics");
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setLoading(true);
    setRefresh(false);
    Request.stations
      .allPoi({
        token: token,
      })
      .then((resp) => {
        setDataStations(resp);
        setLoading(false);
        setIsFirstRefresh(true);
        // setError(false);
      })
      .catch((error) => onError(error));
    // eslint-disable-next-line
  }, [token, refresh_token, refresh]);

  useEffect(() => {
    //Ottengo dalla lista delle stazioni i cluster esistenti
    if (dataStations && !_.isEmpty(dataStations?.stations)) {
      const clusters = dataStations?.stations.filter(
        (value, index, self) =>
          index === self.findIndex((t) => t.cluster === value.cluster)
      );
      const list = clusters.map((item) => {
        return item["cluster"];
      });

      setListClusters(list.sort());
    }
  }, [dataStations, refresh]);

  useEffect(() => {
    if (
      values &&
      !_.isEmpty(values) &&
      values?.time &&
      !_.isEmpty(values?.time)
    ) {
      const newTime = [];
      values?.time.map((item) => {
        return newTime.push(getTimeZoneStandard(item));
      });

      setTime(newTime);
    }
  }, [values]);

  useEffect(() => {
    //setto i valori per la creazione dei grafici
    if (values && !_.isEmpty(values) && time) {
      const air_temp = {
        x:
          !_.isEmpty(time) && !_.isEmpty(values?.air_temp?.data)
            ? time.filter(
              (item, index) => values?.air_temp?.data[index] !== null
            )
            : [],
        y:
          !_.isEmpty(values?.air_temp?.data) &&
            values?.air_temp?.data?.filter((item) => item !== null).length !== 0
            ? values?.air_temp?.data?.filter((item) => item !== null)
            : [],
        ...air_tempLineChart,
      };

      const air_hum = {
        x:
          !_.isEmpty(time) && !_.isEmpty(values?.air_hum?.data)
            ? time.filter(
              (item, index) => values?.air_hum?.data[index] !== null
            )
            : [],
        y:
          !_.isEmpty(values?.air_hum?.data) &&
            values?.air_hum?.data?.filter((item) => item !== null).length !== 0
            ? values?.air_hum?.data?.filter((item) => item !== null)
            : [],
        ...air_humLineChart,
      };

      const co2 = [
        {
          x:
            !_.isEmpty(time) && !_.isEmpty(values?.CO2?.data)
              ? time.filter((item, index) => values?.CO2?.data[index] !== null)
              : [],
          y:
            !_.isEmpty(values?.CO2?.data) &&
              values?.CO2?.data?.filter((item) => item !== null).length !== 0
              ? values?.CO2?.data?.filter((item) => item !== null)
              : [],
          ...co2LineChart,
        },
        {
          x: !_.isEmpty(time) && [time[time.length - 1]],
          y: [700],
          mode: "text",
          text: [`   ${t("Threshold of attention")}`],
          textposition: "top-left",
          type: "scatter",
          line: { color: red[900], width: 1 },
          textfont: {
            size: 11,
            color: red[900],
          },
          name: "",
        },
      ];

      const lux = {
        x:
          !_.isEmpty(time) && !_.isEmpty(values?.lux?.data)
            ? time.filter((item, index) => values?.lux?.data[index] !== null)
            : [],
        y:
          !_.isEmpty(values?.lux?.data) &&
            values?.lux?.data?.filter((item) => item !== null).length !== 0
            ? values?.lux?.data?.filter((item) => item !== null)
            : [],
        ...luxLineChart,
      };

      const bar_press = {
        x:
          !_.isEmpty(time) && !_.isEmpty(values?.bar_press?.data)
            ? time.filter(
              (item, index) => values?.bar_press?.data[index] !== null
            )
            : [],
        y:
          !_.isEmpty(values?.bar_press?.data) &&
            values?.bar_press?.data?.filter((item) => item !== null).length !== 0
            ? values?.bar_press?.data?.filter((item) => item !== null)
            : [],
        ...bar_pressLineChart,
      };

      const pm = [
        {
          x:
            !_.isEmpty(time) && !_.isEmpty(values?.pm2_5?.data)
              ? time.filter(
                (item, index) => values?.pm2_5?.data[index] !== null
              )
              : [],
          y:
            !_.isEmpty(values?.pm2_5?.data) &&
              values?.pm2_5?.data?.filter((item) => item !== null).length !== 0
              ? values?.pm2_5?.data?.filter((item) => item !== null)
              : [],
          ...pmLineChart[0],
        },
        {
          x:
            !_.isEmpty(time) && !_.isEmpty(values?.pm10?.data)
              ? time.filter((item, index) => values?.pm10?.data[index] !== null)
              : [],
          y:
            !_.isEmpty(values?.pm10?.data) &&
              values?.pm10?.data?.filter((item) => item !== null).length !== 0
              ? values?.pm10?.data?.filter((item) => item !== null)
              : [],
          ...pmLineChart[1],
        },
      ];

      const rain = [
        {
          x:
            !_.isEmpty(time) && !_.isEmpty(values?.rain_intensity?.data)
              ? time.filter(
                (item, index) => values?.rain_intensity?.data[index] !== null
              )
              : [],
          y:
            !_.isEmpty(values?.rain_intensity?.data) &&
              values?.rain_intensity?.data?.filter((item) => item !== null)
                .length !== 0
              ? values?.rain_intensity?.data?.filter((item) => item !== null)
              : [],

          ...rainLineChart[0],
          name: t('Intensity')

        },
        {
          x:
            !_.isEmpty(time) && !_.isEmpty(values?.rain_intensity_peak?.data)
              ? time.filter(
                (item, index) =>
                  values?.rain_intensity_peak?.data[index] !== null
              )
              : [],
          y:
            !_.isEmpty(values?.rain_intensity_peak?.data) &&
              values?.rain_intensity_peak?.data?.filter((item) => item !== null)
                .length !== 0
              ? values?.rain_intensity_peak?.data?.filter(
                (item) => item !== null
              )
              : [],
          ...rainLineChart[1],
          name: t(rainLineChart[1].name)

        },
      ];

      const text = [];
      values?.wind_dir_idx?.data_idx !== null &&
        values?.wind_dir_idx?.data_idx.map((item, index) => {
          if (values?.wind_speed?.data[index] !== null)
            return text.push(getIconWindDirection(item));
          return null;
        });

      const wind = [
        {
          x:
            !_.isEmpty(time) && !_.isEmpty(values?.wind_speed?.data)
              ? time.filter(
                (item, index) => values?.wind_speed?.data[index] !== null
              )
              : [],
          y:
            !_.isEmpty(values?.wind_speed?.data) &&
              values?.wind_speed?.data?.filter((item) => item !== null).length !==
              0
              ? values?.wind_speed?.data?.filter((item) => item !== null)
              : [],
          ...windLineChart[0],
        },
        {
          x:
            !_.isEmpty(time) && !_.isEmpty(values?.wind_speed?.data)
              ? time.filter(
                (item, index) => values?.wind_speed?.data[index] !== null
              )
              : [],
          y:
            !_.isEmpty(values?.wind_speed?.data) &&
              values?.wind_speed?.data?.filter((item) => item !== null).length !==
              0
              ? values?.wind_speed?.data?.filter((item) => item !== null)
              : [],
          text: text,
          ...windLineChart[1],
        },
      ];
      const windDir = [
        {
          x:
            !_.isEmpty(time) && !_.isEmpty(values?.wind_dir_idx?.data)
              ? time.filter(
                (item, index) => values?.wind_dir_idx?.data[index] !== null
              )
              : [],
          y:
            !_.isEmpty(values?.wind_dir_idx?.data) &&
              values?.wind_dir_idx?.data?.filter((item) => item !== null)
                .length !== 0
              ? values?.wind_dir_idx?.data?.filter((item) => item !== null)
              : [],
          mode: "lines",
          type: "scatter",
          fill: "tonexty",
          line: { color: cyan[800], width: 1.5 },
          name: "",
        },
        {
          x: [time[0], time[time.length - 1]],
          y: [90, 90],
          mode: "lines+text",
          name: "",
          text: ["E "],
          textposition: "left",
          type: "scatter",
          line: { color: blue[900], width: 1 },
          textfont: {
            size: 14,
            color: blue[800],
          },
        },
        {
          x: [time[0], time[time.length - 1]],
          y: [180, 180],
          mode: "lines+text",
          name: "",
          text: ["S "],
          textposition: "left",
          type: "scatter",
          line: { color: blue[900], width: 1 },
          textfont: {
            size: 14,
            color: blue[800],
          },
        },
        {
          x: [time[0], time[time.length - 1]],
          y: [270, 270],
          mode: "lines+text",
          name: "",
          text: [`${t("W")}`],
          textposition: "left",
          type: "scatter",
          line: { color: blue[900], width: 1 },
          textfont: {
            size: 14,
            color: blue[800],
          },
        },
        {
          x: [time[0], time[time.length - 1]],
          y: [360, 360],
          mode: "lines+text",
          name: "",
          text: ["N "],
          textposition: "left",
          type: "scatter",
          line: { color: blue[900], width: 1 },
          textfont: {
            size: 14,
            color: blue[800],
          },
        },
      ];

      const pcount = {
        x:
          !_.isEmpty(time) && !_.isEmpty(values?.pcount?.data)
            ? time?.filter(
              (item, index) => values?.pcount?.data[index] !== null
            )
            : [],
        y:
          !_.isEmpty(values?.pcount?.data) &&
            values?.pcount?.data?.filter((item) => item !== null).length !== 0
            ? values?.pcount?.data?.filter((item) => item !== null)
            : [],
        ...pcountLineChart,
      };

      setDataMetrics({
        air_temp: {
          value: "air_temp",
          chart: [air_temp],
          shapes: [],
          avg: [
            {
              min: values?.air_temp?.min,
              max: values?.air_temp?.max,
              mean: values?.air_temp?.mean,
              label: t("temperature"),
              ...propsTempertureCard,
            },
          ],
          min: values?.air_temp?.min,
          max: values?.air_temp?.max,
          showlegend: false,
          viewChart:
            !_.isEmpty(values?.air_temp?.data) &&
            values?.air_temp?.data?.filter((item) => item !== null).length !==
            0,
          label: `${t("temperature")} (°C)`,
          symbol: " °C",
        },
        air_hum: {
          value: "air_hum",
          chart: [air_hum],

          avg: [
            {
              min: values?.air_hum?.min,
              max: values?.air_hum?.max,
              mean: values?.air_hum?.mean,
              label: t("humidity"),
              ...propsUmidityCard,
            },
          ],

          min: values?.air_hum?.min,
          max: values?.air_hum?.max,
          showlegend: false,
          viewChart:
            !_.isEmpty(values?.air_hum?.data) &&
            values?.air_hum?.data?.filter((item) => item !== null).length !== 0,
          label: `${t("humidity")} (%)`,
          symbol: " %",
        },
        CO2: {
          value: "CO2",
          chart: co2,
          shapes: [
            {
              type: "line",
              xref: "paper",
              x0: 0,
              y0: 700,
              x1: 1,
              y1: 700,
              line: {
                color: "red",
                width: 2,
              },
            },
          ],
          avg: [
            {
              min: values?.CO2?.min,
              max: values?.CO2?.max,
              mean: values?.CO2?.mean,
              label: "CO2",
              ...propsCo2Card,
            },
          ],
          min: values?.CO2?.min,
          max: values?.CO2?.max,
          showlegend: false,
          viewChart:
            !_.isEmpty(values?.CO2?.data) &&
            values?.CO2?.data?.filter((item) => item !== null).length !== 0,
          label: "CO2 (ppm)",
          symbol: " ppm",
        },
        lux: {
          value: "lux",
          chart: [lux],
          shapes: [],
          avg: [
            {
              min: values?.lux?.min,
              max: values?.lux?.max,
              mean: values?.lux?.mean,
              label: t("illuminance"),
              ...propsLuxCard,
            },
          ],

          min: values?.lux?.min,
          max: values?.lux?.max,
          showlegend: false,
          viewChart:
            !_.isEmpty(values?.lux?.data) &&
            values?.lux?.data?.filter((item) => item !== null).length !== 0,
          label: `${t("illuminance")} (lux)`,
          symbol: " lux",
        },
        pm10: {
          value: "pm10",
          chart: pm,
          shapes: [],
          avg: [
            {
              min: values?.pm10?.min,
              max: values?.pm10?.max,
              mean: values?.pm10?.mean,
              label: "PM 10",
              ...propsPM10Card,
            },
            {
              min: values?.pm2_5?.min,
              max: values?.pm2_5?.max,
              mean: values?.pm2_5?.mean,
              label: "PM 2.5",
              ...propsPM2_5Card,
            },
          ],
          min: Math.min(values?.pm10?.min, values?.pm2_5?.min),
          max: Math.max(values?.pm10?.max, values?.pm2_5?.max),
          showlegend: true,
          viewChart:
            !_.isEmpty(values?.pm10?.data) &&
            values?.pm10?.data?.filter((item) => item !== null).length !== 0 &&
            !_.isEmpty(values?.pm2_5?.data) &&
            values?.pm2_5?.data?.filter((item) => item !== null).length !== 0,
          label: "PM (µg/m³)",
          symbol: " µg/m³",
        },
        rain_intensity: {
          value: "rain_intensity",
          chart: rain,
          shapes: [],
          avg: [
            {
              min: values?.rain_intensity?.min,
              max: values?.rain_intensity?.max,
              mean: values?.rain_intensity?.mean,
              label: t("Rainfall intensity"),
              ...propsRainCard,
            },
            {
              min: values?.rain_intensity_peak?.min,
              max: values?.rain_intensity_peak?.max,
              mean: values?.rain_intensity_peak?.mean,
              label: t("precipitation-peak"),
              ...propsRainPeakCard,
            },
          ],

          min: Math.min(
            values?.rain_intensity?.min,
            values?.rain_intensity_peak?.min
          ),
          max: Math.max(
            values?.rain_intensity?.max,
            values?.rain_intensity_peak?.max
          ),
          showlegend: true,
          viewChart:
            !_.isEmpty(values?.rain_intensity?.data) &&
            values?.rain_intensity?.data?.filter((item) => item !== null)
              .length !== 0 &&
            !_.isEmpty(values?.rain_intensity?.data) &&
            values?.rain_intensity?.data?.filter((item) => item !== null)
              .length !== 0,
          label: `${t("Rainfall")} (mm)`,
          symbol: " mm",
        },
        wind_speed: {
          value: "wind_speed",
          chart: wind,
          shapes: [],
          avg: [
            {
              min: values?.wind_speed?.min,
              max: values?.wind_speed?.max,
              mean: values?.wind_speed?.mean,
              label: t("wind-speed"),
              icon: propsWindCard.icon,
              bgColor: propsWindCard.bgColor,
              avatarcolor: propsWindCard.avatarcolor,
            },
          ],
          min: _.min(values?.wind_speed?.min, values?.wind_dir_idx?.min),
          max: _.max(values?.wind_speed?.max, values?.wind_dir_idx?.max),
          titleChart: t("Wind speed and direction"),
          label: `${t("Speed")} (km/h)`,
          yVisible: false,
          showlegend: false,
          viewChart:
            !_.isEmpty(values?.wind_speed?.data) &&
            values?.wind_speed?.data?.filter((item) => item !== null).length !==
            0,
          symbol: " km/h",
        },
        wind_dir_idx: {
          value: "wind_dir_idx",
          chart: windDir,
          shapes: [],
          avg: [
            {
              min: null,
              max: null,
              mean:
                values?.wind_dir_idx?.mean !== null
                  ? t(WIND_DIRECTION_DICT360[values?.wind_dir_idx?.mean])
                  : null,
              label: t("wind-direction"),
              icon: propsWindCard.icon,
              bgColor: propsWindCard.bgColor,
              avatarcolor: propsWindCard.avatarcolor,
            },
          ],
          showlegend: false,
          min: 0,
          max: 375,
          viewChart:
            !_.isEmpty(values?.wind_dir_idx?.data) &&
            values?.wind_dir_idx?.data?.filter((item) => item !== null)
              .length !== 0,
          yVisible: false,
          label: `${t("Direction")} (360°)`,
        },
        bar_press: {
          value: "bar_press",
          chart: [bar_press],
          shapes: [],
          avg: [
            {
              min: values?.bar_press?.min,
              max: values?.bar_press?.max,
              mean: values?.bar_press?.mean,
              label: t("atmospheric-pressure"),
              ...propsBarPressCard,
            },
          ],
          min: values?.bar_press?.min,
          max: values?.bar_press?.max,
          showlegend: false,
          viewChart:
            !_.isEmpty(values?.bar_press?.data) &&
            values?.bar_press?.data?.filter((item) => item !== null).length !==
            0,
          label: `${t("atmospheric-pressure")} (hPa)`,
          symbol: " hPa",
        },
        pcount: {
          value: "pcount",
          chart: [pcount],
          shapes: [],
          avg: [
            {
              min: values?.pcount?.min,
              max: values?.pcount?.max,
              mean: values?.pcount?.mean,
              label: t("people-counter"),
              ...propsPCountCard,
            },
          ],

          min: values?.pcount?.min,
          max: values?.pcount?.max,
          showlegend: false,
          viewChart:
            !_.isEmpty(values?.pcount?.data) &&
            values?.pcount?.data?.filter((item) => item !== null).length !== 0,
          label: t("Number of person"),
          symbol: " pers.",
        },
      });
      setLoadingData(false);
    }
  }, [values, theme, refresh, time, t]);

  useEffect(() => {
    //ottengo la lista delle stazioni associate a un determianto cluster
    if (zoneSelected && !_.isEmpty(zoneSelected)) {
      setLoading(true);
      const clustersList = [];
      dataStations?.stations?.map((item) =>
        zoneSelected.map(
          (zone) =>
            item.cluster === zone &&
            clustersList.push(
              `${item.stationId} - ${item.cluster} - ${item.address}`
            )
        )
      );
      setListStationsId(clustersList.sort());
      setLoading(false);
    } else {
      setStationIdSelected(null);
      dispatch(saveStationID(null));
    }
    // eslint-disable-next-line
  }, [zoneSelected, token, dataStations, global, refresh]);

  useEffect(() => {
    let path = null;
    setLoadingData(true);

    if (
      dateStart &&
      DateTime.fromISO(dateStart).isValid &&
      dateEnd &&
      DateTime.fromISO(dateEnd).isValid
    ) {
      const start = getTimeZoneLondon(
        new DateTime(dateStart).toFormat("yyyy-MM-dd'T'HH:mm:ss")
      );
      const end = getTimeZoneLondon(
        new DateTime(dateEnd).toFormat("yyyy-MM-dd'T'HH:mm:ss")
      );

      path =
        _.isEmpty(zoneSelected) || stationIdSelected !== null
          ? `?datetime_start=${start}&datetime_end=${end}`
          : `?cluster=${zoneSelected}&datetime_start=${start}&datetime_end=${end}`;
    } else {
      if (dateStart && DateTime.fromISO(dateStart).isValid) {
        const start = getTimeZoneLondon(
          new DateTime(dateStart).toFormat("yyyy-MM-dd'T'HH:mm:ss")
        );

        path =
          _.isEmpty(zoneSelected) || stationIdSelected !== null
            ? `?datetime_start=${start}`
            : `?cluster=${zoneSelected}&datetime_start=${start}`;
      } else {
        if (dateEnd && DateTime.fromISO(dateEnd).isValid) {
          const end = getTimeZoneLondon(
            new DateTime(dateEnd).toFormat("yyyy-MM-dd'T'HH:mm:ss")
          );

          path =
            _.isEmpty(zoneSelected) || stationIdSelected !== null
              ? `?datetime_end=${end}`
              : `?cluster=${zoneSelected}&datetime_end=${end}`;
        } else {
          if (!dateStart && !dateEnd) {
            //se la data non è selzionata ottengo dati delle ultime 24 h
            path =
              _.isEmpty(zoneSelected) || stationIdSelected !== null
                ? ""
                : `?cluster=${zoneSelected}`;
          }
        }
      }
    }

    if (path !== null) {
      if (stationIdSelected) {
        Request.stations
          .getDataStationIdGeneric({
            station_id: _.split(stationIdSelected, "-")[0].trim(),
            token: token,
            path: path,
          })
          .then((resp) => onSuccess(resp))
          .catch((error) => onError(error));
      } else {
        Request.stations
          .getDataGeneric({ token: token, path: path })
          .then((resp) => onSuccess(resp))
          .catch((error) => onError(error));
      }
    }
    // eslint-disable-next-line
  }, [
    dateStart,
    dateEnd,
    zoneSelected,
    stationIdSelected,
    global,
    refresh,
    token,
    refresh_token,
  ]);

  useEffect(() => {
    if (
      success &&
      (values === null ||
        _.isEmpty(
          Object.values(values).filter(
            (item) =>
              item &&
              item.data !== null &&
              item.min !== null &&
              item.max !== null &&
              item.mean !== null
          )
        ))
    ) {
      setError(true);
    }
  }, [values, success]);

  return (
    <Grid container spacing={2} mt={-1}>
      <Grid item xs={12}>
        <SelectZoneAndStationCard
          onRefresh={onRefresh}
          hasRefresh
          listClusters={listClusters}
          handleChangeZone={handleChangeZone}
          listStationsId={listStationsId}
          loading={loading}
          zoneSelected={zoneSelected}
          stationIdSelected={stationIdSelected}
          handleChangeStationIdSelected={handleChangeStationIdSelected}
        />
      </Grid>

      <Grid item xs={12}>
        <StatsContainer
          zoneSelected={zoneSelected}
          stationIdSelected={stationIdSelected}
          user={user}
          onError={onError}
          refresh={refresh}
        />
      </Grid>

      <Grid item xs={12}>
        <CurrentDataContainer
          zoneSelected={zoneSelected}
          stationIdSelected={_.split(stationIdSelected, "-")[0].trim()}
          onFailure={onFailure}
          refresh={refresh}
          isAccordion={true}
        />
      </Grid>

      <Grid item xs={12}>
        <SelectDateStartAndEndComponent
          onChangeValueDate={onChangeValueDate}
          onChangeDateStart={onChangeDateStart}
          onChangeDateEnd={onChangeDateEnd}
          valueData={valueData}
          dateStart={dateStart}
          dateEnd={dateEnd}
        />
      </Grid>

      <Grid item xs={12} sm={6} />

      {loadingData ? (
        <Grid item xs={12}>
          <Loading />
        </Grid>
      ) : (
        <Grid item container spacing={4}>
          {error ? (
            <Grid item xs={12}>
              <ErrorCardcomponent message={t("No data for selected filters")} />
            </Grid>
          ) : (
            values &&
            dataMetrics &&
            Object.keys(dataMetrics).map(
              (key) =>
                values[key]?.data && (
                  <Grid item xs={12} sm={12} lg={6} md={6} key={key}>
                    <Grid item container xs={12} spacing={2}>
                      {dataMetrics[key].avg.map((item, index) => (
                        <Grid
                          item
                          xs={12}
                          sm={dataMetrics[key].avg.length > 1 ? 6 : 12}
                          md={12}
                          lg={dataMetrics[key].avg.length > 1 ? 6 : 12}
                          key={index}
                        >
                          <MetricCard
                            isTrend={false}
                            {...item}
                            symbol={t(dataMetrics[key].symbol)}
                            onClickCard={() =>
                              onClickCard(dataMetrics[key]?.value)
                            }
                          />
                        </Grid>
                      ))}
                      {dataMetrics[key].viewChart ? (
                        <Grid item xs={12}>
                          <LineChartPlotly
                            isLoading={loading}
                            data={dataMetrics[key]?.chart}
                            yLabel={dataMetrics[key]?.label}
                            yRange={
                              key === "bar_press"
                                ? [
                                  dataMetrics[key]?.min -
                                  Math.abs(dataMetrics[key]?.min * 0.005),
                                  dataMetrics[key]?.max +
                                  Math.abs(dataMetrics[key]?.max * 0.005),
                                ]
                                : key === "air_temp" ||
                                  (key !== "air_temp" &&
                                    dataMetrics[key]?.max !== 0)
                                  ? getMinMaxLineChart(
                                    dataMetrics[key]?.min,
                                    dataMetrics[key]?.max
                                  )
                                  : [0, 2]
                            }
                            shapes={dataMetrics[key]?.shapes}
                            titleChart={dataMetrics[key]?.titleChart}
                            showlegend={dataMetrics[key]?.showlegend}
                            yVisible={dataMetrics[key]?.yVisible}
                            xRange={
                              time ? [time[0], time[time.length - 1]] : []
                            }
                          />
                        </Grid>
                      ) : (
                        <Grid item xs={12}>
                          <ErrorCardcomponent
                            message={t("No data for selected filters")}
                          />
                        </Grid>
                      )}
                    </Grid>
                  </Grid>
                )
            )
          )}
        </Grid>
      )}
    </Grid>
  );
};

export default GlobalEnviromentContainer;
